import type { RouteComponentProps } from "react-router-dom";

import type { BreadcrumbTrailItem } from "~/common/redesign-v1";

import { createRedesignEntry } from "../redesign-page-entry";

type PlanRoute = RouteComponentProps<{ patient_id: string; case_id: string }>;

function patientTrail(patientId: string | undefined): BreadcrumbTrailItem[] | undefined {
  if (!patientId) return undefined;
  return [
    {
      id: "redesign.shell.patient",
      defaultMessage: "Patient {id}",
      values: { id: patientId },
      to: `/pages/patient/${patientId}`,
    },
  ];
}

export const PlanApproveRedesignEntry = createRedesignEntry<PlanRoute>(() => import("./plan-approve-page"), {
  testId: "rd-plan-approve-loading-chunk",
  shell: (props) => ({
    activeNav: "patients",
    breadcrumbTrail: patientTrail(props.match?.params?.patient_id),
    breadcrumbLeaf: { id: "plan.approve.header", defaultMessage: "3D plan approval" },
  }),
});

export const PlanReworkRedesignEntry = createRedesignEntry<PlanRoute>(() => import("./plan-rework-page"), {
  testId: "rd-plan-rework-loading-chunk",
  shell: (props) => ({
    activeNav: "patients",
    breadcrumbTrail: patientTrail(props.match?.params?.patient_id),
    breadcrumbLeaf: { id: "plan.rework.header", defaultMessage: "3D plan rework" },
  }),
});
